import Cookies from 'js-cookie';

/**
 * Determine if the current user is logged in as a CACM member.
 *
 * @returns boolean
 * @see https://github.com/alleyinteractive/wp-light-sessions#using-with-javascript
 */
export function isUserLoggedIn() { // eslint-disable-line import/prefer-default-export
  return Cookies.get('wpls_is_user_logged_in') === '1';
}

/**
 * Get the current member's preference for displaying ads.
 *
 * @returns boolean
 * @see https://github.com/alleyinteractive/wp-light-sessions#using-with-javascript
 */
export function userShowAds() { // eslint-disable-line import/prefer-default-export
  return Cookies.get('cacm_user_enabled_ads') === 'true';
}
